let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6VUG6")).then(() => parcelRequire('2GFfB'));